import { LOGIC_OPERATOR } from '../views/Competitions/models/logicOperator'
import { OPERATOR } from '../views/Competitions/models/operator'
import { COMPETITION_FIELD_TYPE, COMPETITION_SPECIAL_FILTER } from '../views/Competitions/models/competitionFieldType'
import { CURRENCY } from '../constants/currency'

const removeWhiteSpaces = string => {
  const stringWithoutWhiteSpaces = string.replace(/ /g, '')
  return stringWithoutWhiteSpaces.split(',')
}

const convertNumberCondition = conditions => {
  var result = []
  conditions.forEach(c => {
    let value = c.value
    if (c.currency === CURRENCY.EUR) {
      value = (parseInt(value) * 360).toString()
    }
    const conditionResult = {
      logic: LOGIC_OPERATOR.AND,
      operator: c.operator,
      operands: [value]
    }
    result.push(conditionResult)
  })
  return result
}

const convertFinanceDataCondition = conditions => {
  var result = []
  conditions.forEach(c => {
    const conditionResult = {
      startYear: c.startYear,
      lastYear: c.lastYear,
      operator: c.operator,
      percentage: c.percentage
    }
    result.push(conditionResult)
  })
  return result
}

const convertAnnualDataCondition = conditions => {
  var result = []
  conditions.forEach(c => {
    let currencyDivisior = 1
    if (c.currency === CURRENCY.EUR) {
      currencyDivisior = 360
    }

    const conditionResult = {
      year: c.year,
      operator: c.operator,
      value: c.value * currencyDivisior
    }
    result.push(conditionResult)
  })
  return result
}

const convertArrayCondition = conditions => {
  var result = []
  conditions.forEach(c => {
    const operands = removeWhiteSpaces(c.value)
    const conditionResult = {
      logic: c.logic,
      operator: c.operator,
      operands
    }
    result.push(conditionResult)
  })
  return result
}

const convertBooleanCondition = conditions => {
  var result = []
  conditions.forEach(c => {
    const conditionResult = {
      logic: LOGIC_OPERATOR.AND,
      operator: OPERATOR.EQ,
      operands: c.value
    }
    result.push(conditionResult)
  })
  return result
}

export const convertFieldForms = fieldForms => {
  var conditions = {}
  Object.keys(fieldForms).map(key => {
    const field = fieldForms[key]

    if (COMPETITION_SPECIAL_FILTER.SPECIAL_FINANCE_DATA_FIELDS.includes(field.fieldForm.field)) {
      if (field.conditions !== null && field.conditions.length !== 0) {
        conditions[field.fieldForm.field] = {
          logic: LOGIC_OPERATOR.AND,
          conditions: convertFinanceDataCondition(field.conditions)
        }
      }
      return
    } else if (COMPETITION_SPECIAL_FILTER.SPECIAL_ANNUAL_DATA_FIELDS.includes(field.fieldForm.field)) {
      if (field.conditions !== null && field.conditions.length !== 0) {
        conditions[field.fieldForm.field] = {
          logic: LOGIC_OPERATOR.AND,
          conditions: convertAnnualDataCondition(field.conditions)
        }
      }
    } else {
      switch (field.fieldForm.type.mainType) {
        case COMPETITION_FIELD_TYPE.ARRAY: {
          if (field.conditions !== null && field.conditions.length !== 0) {
            conditions[field.fieldForm.field] = {
              logic: LOGIC_OPERATOR.AND,
              conditions: convertArrayCondition(field.conditions)
            }
          }
          break
        }
        case COMPETITION_FIELD_TYPE.NUMBER: {
          if (field.conditions !== null && field.conditions.length !== 0) {
            conditions[field.fieldForm.field] = {
              logic: LOGIC_OPERATOR.AND,
              conditions: convertNumberCondition(field.conditions)
            }
          }
          break
        }
        case COMPETITION_FIELD_TYPE.BOOLEAN: {
          if (field.conditions !== null && field.conditions.length !== 0) {
            conditions[field.fieldForm.field] = {
              logic: LOGIC_OPERATOR.AND,
              conditions: convertBooleanCondition(field.conditions)
            }
          }
          break
        }
        default:
          throw new Error('Unknown company field type when converting fields')
      }
    }
  })
  const conditionKeys = Object.keys(conditions)
  if (conditionKeys.length === 0) {
    return []
  } else {
    return [conditions]
  }
}

export const convertBooleanServerResponse = responseConditions => {
  const result = []
  responseConditions.forEach(condition => {
    let convertedCondition = {
      value: condition.operands,
      operator: condition.operator,
      logic: condition.logic
    }
    result.push(convertedCondition)
  })
  return result
}

export const convertArrayServerResponse = responseConditions => {
  const result = []
  responseConditions.forEach(condition => {
    let convertedCondition = {
      value: condition.operands.join(','),
      operator: condition.operator,
      logic: condition.logic
    }
    result.push(convertedCondition)
  })
  return result
}

export const convertNumberServerResponse = (responseConditions, fieldForm) => {
  const result = []
  responseConditions.forEach(condition => {
    let convertedCondition = { value: condition.operands[0], operator: condition.operator }
    if (fieldForm.type.additionalType === COMPETITION_FIELD_TYPE.CURRENCY) {
      convertedCondition = { ...convertedCondition, currency: CURRENCY.HUF }
    }
    result.push(convertedCondition)
  })
  return result
}

export const convertFinanceDataServerResponse = responseConditions => {
  const result = []
  responseConditions.forEach(condition => {
    let convertedCondition = {
      startYear: condition.startYear,
      lastYear: condition.lastYear,
      operator: condition.operator,
      percentage: condition.percentage
    }
    result.push(convertedCondition)
  })
  return result
}

export const convertAnnualDataServerResponse = responseConditions => {
  const result = []
  responseConditions.forEach(condition => {
    let currencyDivisior = 1
    if (condition.currency === CURRENCY.EUR) {
      currencyDivisior = 360
    }

    let convertedCondition = {
      year: condition.year,
      operator: condition.operator,
      value: condition.value * currencyDivisior
    }
    result.push(convertedCondition)
  })
  return result
}
